import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import type { FormattedWatchlistHit } from '../../../../../../onboarding-business-insight.types';
import HitItem from '../hit-item';
type HitsListProps = {
  name: string | undefined;
  hits: FormattedWatchlistHit[];
};
const HitsList = t0 => {
  const $ = _c(10);
  const {
    name,
    hits
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings.watchlist.list"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  if (hits.length === 0) {
    let t2;
    if ($[1] !== name || $[2] !== t) {
      t2 = name ? t(_temp, {
        name
      }) : t(_temp2);
      $[1] = name;
      $[2] = t;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== t2) {
      t3 = <span className="text-body-2 text-tertiary">{t2}</span>;
      $[4] = t2;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  let t2;
  if ($[6] !== hits) {
    t2 = hits.map(_temp3);
    $[6] = hits;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t2) {
    t3 = <div className="flex flex-col gap-2">{t2}</div>;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
export default HitsList;
function _temp($) {
  return $.emptyState;
}
function _temp2($_0) {
  return $_0.emptyStateNoEntity;
}
function _temp3(hit) {
  return <HitItem key={`${hit.entityName} ${hit.listName}`} hit={hit} />;
}